import { globals, page as pageIndex } from '../../globals'
import { HIDE_MODAL } from './modal'
// ------------------------------------
// Constants
// ------------------------------------
export const CLEAR_FILTERS = 'CLEAR_FILTERS'
export const RETURN_DEFAULT_REPORT = 'RETURN_DEFAULT_REPORT'
export const OPEN_SAVED_REPORT = 'OPEN_SAVED_REPORT'

export const GET_REPORT_START = 'GET_REPORT_START'
export const GET_REPORT_SUCCESS = 'GET_REPORT_SUCCESS'
export const GET_REPORT_FAILED = 'GET_REPORT_FAILED'

export const TOTAL_MATCHES_START = 'TOTAL_MATCHES_START'
export const TOTAL_MATCHES_SUCCESS = 'TOTAL_MATCHES_SUCCESS'
export const TOTAL_MATCHES_FAILED = 'TOTAL_MATCHES_FAILED'

export const GET_SAVED_REPORTS_START = 'GET_SAVED_REPORTS_START'
export const GET_SAVED_REPORTS_FETCHED = 'GET_SAVED_REPORTS_FETCHED'
export const GET_SAVED_REPORTS_FAILED = 'GET_SAVED_REPORTS_FAILED'

export const SAVE_SUBJECT_REPORT = 'SAVE_SUBJECT_REPORT'
export const NEW_REPORT_SAVED = 'NEW_REPORT_SAVED'
export const SAVE_REPORT_FAILED = 'SAVE_REPORT_FAILED'

export const DELETE_REPORT_START = 'DELETE_REPORT_START'
export const REPORT_DELETED = 'REPORT_DELETED'
export const DELETE_REPORT_FAILED = 'DELETE_REPORT_FAILED'

export const UPDATE_SUBJECT_REPORT = 'UPDATE_SUBJECT_REPORT'
export const REPORT_UPDATED = 'REPORT_UPDATED'
export const UPDATE_REPORT_FAILED = 'UPDATE_REPORT_FAILED'

export const DUPLICATED_REPORT_NAME = 'DUPLICATED_REPORT_NAME'

export const GET_ALL_SAVED_REPORTS_START = 'GET_ALL_SAVED_REPORTS_START'
export const GET_ALL_SAVED_REPORTS_FAILED = 'GET_ALL_SAVED_REPORTS_FAILED'
export const GET_ALL_SAVED_REPORTS_FETCHED = 'GET_ALL_SAVED_REPORTS_FETCHED'

// ------------------------------------
// Actions
// ------------------------------------
export const actions = {
  openReport,
  getReport,
  getNumberMatches,
  getAllSavedReports,
  getSavedReportsByUsage,
  saveNewReport,
  deleteSavedReport,
  updateReport,
  clearFilters,
  returnDefaultState
}

function mapSavedReports (optionsData, id) {
  return optionsData.map(item => {
    if (item.UserId === id && item.IsPrivate === true) {
      return {
        ReportId: item.ReportId,
        Name: item.Name,
      }
    } else if (item.UserId === id && item.IsPrivate === false) {
      return {
        ReportId: item.ReportId,
        Name: `${item.Name}-MyShared`,
      }
    } else if (item.UserId !== id) {
      return {
        ReportId: item.ReportId,
        Name: `${item.Name}-Shared`,
      }
    }
  })
}

function returnMapResults (data) {
  const newData = data.replace(/(US-)/g, '')
  const parsedData = JSON.parse(newData)
  const totalNum = Math.max.apply(null, Object.values(parsedData))
  localStorage.setItem('maxValue', totalNum)
  let lowN
  let highN
  switch (totalNum) {
    case 0:
    case 1:
      lowN = totalNum
      highN = totalNum
      break
    case 2:
    case 3:
      lowN = totalNum + 1
      highN = totalNum - 1
      break
    default:
      lowN = Math.round(totalNum * 0.3333)
      highN = Math.round(totalNum * 0.6666)
      break
  }
  const trackData = JSON.parse(localStorage.getItem('trackData')).maps.selected
  for (let key in parsedData) {
    if (parsedData.hasOwnProperty(key)) {
      const result = parsedData[key]
      const colorRange = result === 0
        ? 'defaultFill'
        : (result > 0 && result < lowN)
          ? 'low'
          : (result >= lowN && result <= highN)
            ? 'medium'
            : result > highN ? 'high' : 'defaultFill'
      const colorRangeBill = result === 0 ? 'defaultFill' : 'found'
      if (key === 'US') {
        parsedData['US Federal'] = {}
        parsedData['US Federal'].name = key
        parsedData['US Federal'].records = result
        parsedData['US Federal'].fillKey = trackData.length === 0 ? colorRange : colorRangeBill
      } else {
        parsedData[key] = {}
        parsedData[key].name = key
        parsedData[key].records = result
        parsedData[key].fillKey = trackData.length === 0 ? colorRange : colorRangeBill
      }
    }
  }
  delete parsedData['US']
  return parsedData
}

export function clearFilters (page) {
  return {
    type: CLEAR_FILTERS,
    page
  }
}

const headers = {
  'Content-Type': 'application/json'
}

export function openReport (page, id) {
  return (dispatch) => {
    dispatch({ type: GET_SAVED_REPORTS_START })
    const options = {
      method: 'GET',
      headers,
      credentials: 'include'
    }
    fetch(`${globals.apiUrl}/api/searchreport/${id}`, options).then((response) => {
      if (response.status === 200) {
        return response.json()
      } else {
        dispatch({
          type: GET_SAVED_REPORTS_FAILED,
          payload: {
            errorCode: response.status
          }
        })
      }
    }).then((json) => {
      if (json) {
        dispatch({
          type: OPEN_SAVED_REPORT,
          payload: {
            json
          },
          page: page,
          id: id
        })
      }
    }).catch((err) => {
      console.log(err)
      dispatch({ type: GET_SAVED_REPORTS_FAILED })
    })
  }
}

export function getReport (searchRequestData, page) {
  const endpoint = page === pageIndex.billFinder ? 'searchtext' : 'search'
  return (dispatch) => {
    dispatch({ type: GET_REPORT_START })
    const options = {
      method: 'POST',
      credentials: 'include',
      headers,
      body: JSON.stringify(searchRequestData)
    }
    fetch(`${globals.apiUrl}/api/${endpoint}`, options).then((response) => {
      if (response.status === 200) {
        return response.json()
      }
    }).then((json) => {
      if (json) {
        dispatch({
          type: GET_REPORT_SUCCESS,
          payload: {
            json
          }
        })
      }
    }).catch((err) => {
      console.log(err)
      dispatch({ type: GET_REPORT_FAILED })
    })
  }
}

export function getNumberMatches (searchRequestData, page) {
  const endpoint = page === pageIndex.billFinder ? 'searchtext' : 'search'
  return (dispatch) => {
    dispatch({ type: TOTAL_MATCHES_START })
    const options = {
      method: 'POST',
      credentials: 'include',
      headers,
      body: JSON.stringify(searchRequestData)
    }
    fetch(`${globals.apiUrl}/api/${endpoint}`, options).then((response) => {
      if (response.status === 200) {
        return response.json()
      }
    }).then((json) => {
      if (json || typeof json === 'number') {
        dispatch({
          type: TOTAL_MATCHES_SUCCESS,
          payload: {
            json
          }
        })
      }
    }).catch((err) => {
      console.log(err)
      dispatch({ type: TOTAL_MATCHES_FAILED })
    })
  }
}

export function getSavedReportsByUsage (page, id) {
  return (dispatch) => {
    dispatch({ type: GET_SAVED_REPORTS_START })
    const options = {
      method: 'GET',
      credentials: 'include',
      headers
    }
    fetch(`${globals.apiUrl}/api/searchreport?usage=${page}`, options).then((response) => {
      if (response.status === 200) {
        return response.json()
      } else {
        dispatch({ type: GET_SAVED_REPORTS_FAILED, payload: { errorCode: response.status } })
      }
    }).then((json) => {
      if (json) {
        dispatch({
          type: GET_SAVED_REPORTS_FETCHED,
          payload: {
            json
          },
          id
        })
      }
    }).catch((err) => {
      console.log(err)
      dispatch({ type: GET_SAVED_REPORTS_FAILED })
    })
  }
}

export function getAllSavedReports () {
  return (dispatch) => {
    dispatch({ type: GET_ALL_SAVED_REPORTS_START })
    const options = {
      method: 'GET',
      credentials: 'include',
      headers
    }
    fetch(`${globals.apiUrl}/api/searchreport`, options).then((response) => {
      if (response.status === 200) {
        return response.json()
      } else {
        dispatch({ type: GET_ALL_SAVED_REPORTS_FAILED, payload: { errorCode: response.status } })
      }
    }).then((json) => {
      if (json) {
        dispatch({
          type: GET_ALL_SAVED_REPORTS_FETCHED,
          payload: {
            json
          }
        })
      }
    }).catch((err) => {
      console.log(err)
      dispatch({ type: GET_ALL_SAVED_REPORTS_FAILED })
    })
  }
}

export function saveNewReport (searchReportFormData, name) {
  return (dispatch) => {
    dispatch({ type: SAVE_SUBJECT_REPORT })
    const options = {
      method: 'POST',
      credentials: 'include',
      headers,
      body: JSON.stringify(searchReportFormData)
    }
    fetch(`${globals.apiUrl}/api/searchreport`, options).then((response) => {
      if (response.status === 200) {
        dispatch({ type: HIDE_MODAL })
        return response.json()
      } else if (response.status === 400) {
        dispatch({
          type: DUPLICATED_REPORT_NAME
        })
      }
    }).then((json) => {
      if (json) {
        dispatch({
          type: NEW_REPORT_SAVED,
          payload: {
            json,
            name
          }
        })
      }
    }).catch((err) => {
      console.log(err)
      dispatch({ type: SAVE_REPORT_FAILED })
    })
  }
}

export function updateReport (searchReportFormData, id) {
  return (dispatch) => {
    dispatch({ type: UPDATE_SUBJECT_REPORT })
    const options = {
      method: 'PUT',
      credentials: 'include',
      headers,
      body: JSON.stringify(searchReportFormData)
    }
    fetch(`${globals.apiUrl}/api/searchreport/${id}`, options).then((response) => {
      if (response.status === 200) {
        dispatch({ type: HIDE_MODAL })
        return response.json()
      }
    }).then((json) => {
      if (json) {
        dispatch({
          type: REPORT_UPDATED,
          payload: {
            json
          }
        })
      }
    }).catch((err) => {
      console.log(err)
      dispatch({ type: UPDATE_REPORT_FAILED })
    })
  }
}

export function deleteSavedReport (page, id, data) {
  return (dispatch) => {
    dispatch({ type: DELETE_REPORT_START })
    const options = {
      method: 'DELETE',
      credentials: 'include',
      headers
    }
    fetch(`${globals.apiUrl}/api/searchreport/${id}`, options).then((response) => {
      if (response.status === 200) {
        return response.json()
      }
    }).then((json) => {
      if (json) {
        dispatch({
          type: REPORT_DELETED,
          payload: {
            json
          }
        })
        if (!data) {
          dispatch(getAllSavedReports())
        } else if (data.defaultReport !== null) {
          dispatch(openReport(page, data.defaultReport.ReportId))
        } else {
          dispatch(returnDefaultState(page, []))
        }
      }
    }).catch((err) => {
      console.log(err)
      dispatch({ type: DELETE_REPORT_FAILED })
    })
  }
}

export function returnDefaultState (page, data) {
  if (!data) {
    return {
      type: RETURN_DEFAULT_REPORT,
      page
    }
  } else {
    return {
      type: OPEN_SAVED_REPORT,
      payload: {
        json: data
      },
      page
    }
  }
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [TOTAL_MATCHES_SUCCESS] : (state, action) => {
    const field = 'totalMatches'
    const { json } = action.payload
    return {
      ...state,
      isFetchingData: false,
      renderData: {
        ...state.renderData,
        [field]: json
      }
    }
  },
  [GET_REPORT_START] : (state) => {
    return {
      ...state,
      isFetchingData: true
    }
  },
  [GET_REPORT_SUCCESS] : (state, action) => {
    const { json } = action.payload
    return {
      ...state,
      isFetchingData: false,
      renderData: {
        ...state.renderData,
        results: typeof json === 'string' ? returnMapResults(json) : json
      }
    }
  },
  [GET_SAVED_REPORTS_FETCHED] : (state, action) => {
    const { id } = action
    const { json } = action.payload
    return {
      ...state,
      isFetchingData: false,
      renderData: {
        ...state.renderData,
        reportItems: mapSavedReports(json, id)
      },
      formDataValue: {
        ...state.formDataValue
      }
    }
  },
  [GET_SAVED_REPORTS_FAILED] : (state) => {
    return {
      ...state,
      isFetchingData: false,
      renderData: {
        ...state.renderData,
        reportItems: []
      },
      formDataValue: {
        ...state.formDataValue
      }
    }
  },
  [DUPLICATED_REPORT_NAME] : (state) => {
    return {
      ...state,
      isFetchingData: false,
      renderData: {
        ...state.renderData,
        duplicatedReportName: true
      }
    }
  },
  [GET_ALL_SAVED_REPORTS_START] : (state) => {
    return {
      ...state,
      isFetchingData: true
    }
  },
  [GET_ALL_SAVED_REPORTS_FETCHED] : (state, action) => {
    const { json } = action.payload
    return {
      ...state,
      isFetchingData: false,
      renderData: {
        ...state.renderData,
        savedReports: json
      }
    }
  }
}
// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
  isFetchingData: true,
  errorCode: '',
  renderData: {}
}
export default function reportLineReducer (state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/store/reducers/reportLine.js